import { UnitOfMeasureEnum } from "../../../shared/components/formulario/select/SelectUnitOfMeasure";
import { ModalityEnum, WorkStatusEnum } from "../../../shared/utils/enum/enum";

export const getStatusLabel = (status: WorkStatusEnum): string => {
  switch (status) {
    case WorkStatusEnum.IN_PROGRESS:
      return "Em andamento";
    case WorkStatusEnum.STAR:
      return "Iniciada";
    case WorkStatusEnum.FINALIZING:
      return "Finalizando";
    case WorkStatusEnum.FINISHED:
      return "Concluída";
    case WorkStatusEnum.CANCELED:
      return "Cancelada";
    case WorkStatusEnum.PAUSED:
      return "Pausada";
    case WorkStatusEnum.WAITING_CONFIRMATION:
      return "Aguardando Início";
    case WorkStatusEnum.ACTIVE:
      return "Ativa";
    case WorkStatusEnum.DISABLED:
      return "Desativada";
    default:
      return "Desconhecido";
  }
};

export interface CriarObraContract {
  workName: string,
  idClient: string,
  startDate: Date,
  endDate: Date,
  totalValue: number,
  description: string | null,
  address: {
    zipCode: string,
    street: string,
    number: string,
    neighborhood: string,
    city: string,
    state: string,
    complement: string,
  },
  contractFile: File,
  workStages: {
    name: string,
    description?: string | null,
    startDate: Date,
    endDate: Date,
    order?: number | null,
  }[],
  positionsDto: {
    name: string;
    description: string;
    active: boolean;
    priceDto: {
      value: number;
      modality: UnitOfMeasureEnum;
      active: boolean;
    }[]
  }[]
}